<tec-modal [isVisible]="isVisible"
	[title]="'CONNECTIONS.IRPF.FORM.SOPORTE' | translate"
	(closeEvent)="closeModal()">
	<ng-container body>
		<span class="text-align-center" [innerHTML]="'CONNECTIONS.IRPF.FORM.SOPORTE_DESCRIPTION' | translate"></span>
        <div style="align-self: center; width: 280px">
            <pwcs-inline-svg src="assets/images/nie-soporte-help.svg" idSuffix="modal-nie-soporte-help" />
        </div>
	</ng-container>
</tec-modal>
